import styled from "styled-components";
export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  width: 94%;
  margin-left: 2.5em;
  #filter-status-select-label {
    font-size: 13px;
  }
  #filter-date-select-label {
    font-size: 13px;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.button.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked {
    color: ${({ theme }) => theme.button.primary};
  }
  .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
    font-size: 13px;
  }
`;

export const ContentFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1em;
  margin: 2em 0px;
  width: 20%;
`;

export const ResetButton = styled.button`
  width: 55px;
  height: 25px;
  background: #f2f2f2;
  color: ${({ theme }) => theme.button.primary};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  font-size: 14px;
  font-weight: 500;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const TableViewButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const SearchField = styled.div`
  margin-right: 0.5rem;
  width: 185px;
  height: 40px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;

export const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: "#8F9BB3",
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};
